@for (item of vaps; track item; let i = $index) {
  <div class="addon-expander addon-expander--checkbox">
    <div class="addon-expander__header">
      <label class="custom-input custom-input--checkbox">
        <input type="checkbox"
          [checked]="item?.checked"
          [id]="'checkbox' + currentVap?.product_vaps_id + '-' + item?.session_item_id"
          (click)="checkAddon(i)"
          [class]="'addon-' + currentVap?.product_vaps_id" />
          <span class="custom-input__indi"></span>
        </label>
        <a [href]="'#addon-vehicle-field-' + currentVap?.product_vaps_id"
          class="addon-expander__title"
          [ngClass]="{'collapsed': !item?.show}"
          data-toggle="collapse"
          aria-expanded="false">
          <h6>{{item?.description?.length ? item?.description[2] : ''}}</h6>
          <div class="addon-expander__cost" [ngClass]="{'is-active': item?.is_active}">
            <p>
              <strong [class]="currentVap?.product_vaps_id + '-' + item?.session_item_id + '-price addon-price-' + currentVap?.product_vaps_id">
                {{item?.price | currency:'ZAR':'R ':'1.0-0'}}
              </strong> /mo
            </p>
          </div>
          <div class="addon-expander__caret">
            <svg class="icon"></svg>
          </div>
        </a>
      </div>
    </div>
  }
